import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import boxImg from '../assets/box.png';
import truckImg from '../assets/truck.png';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export default function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();

    const login = async () => {
        try {
            const res = await axios.post(`${backendUrl}/api/login`, { username, password });
            if (res.data.success) {
                if (res.data.role === 'Admin') {
                    navigate('/admin');
                } else {
                    navigate('/loader');
                }
            } else {
                alert('Login failed: ' + res.data.message);
            }
        } catch (err) {
            alert('Server error');
        }
    };
    return (
        <div className="flex flex-col-reverse lg:flex-row min-h-screen bg-black text-white font-sans">

            {/* Login Form */}
            <div className="w-full lg:w-1/2 flex justify-center items-center p-4 sm:p-6 md:p-8">
                <div className="w-full max-w-md bg-black border-2 border-orange-500 rounded-xl shadow-2xl p-6 sm:p-8 flex flex-col items-center">
                    <h1 className="text-2xl sm:text-3xl font-extrabold mb-2 text-orange-500 tracking-wide">Welcome</h1>
                    <p className="text-gray-400 mb-6 sm:mb-8 text-xs sm:text-sm text-center">Sign in to your dashboard</p>

                    <input
                        className="mb-4 p-3 w-full bg-gray-900 border border-orange-500 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 transition text-sm"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <div className="relative w-full mb-6">
                        <input
                            className="p-3 w-full bg-gray-900 border border-orange-500 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400 transition pr-10 text-sm"
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white"
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>
                    <button
                        onClick={login}
                        className="relative overflow-hidden bg-[#FF8A0C]/20 backdrop-blur-md border border-[#FF8A0C]/30 rounded-full text-[#FF8A0C] font-semibold py-4 px-8 cursor-pointer transition duration-300 ease-in-out hover:bg-[#FF8A0C]/30 hover:border-[#FF8A0C]/50 hover:-translate-y-1 hover:shadow-[0_15px_35px_rgba(255,138,12,0.2)] hover:text-white active:-translate-y-0.5 flex items-center gap-3 justify-center w-auto"
                    >
                        Get Started
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5l7 7-7 7"
                            />
                        </svg>
                    </button>

                    <p className="mt-4 text-xs sm:text-sm text-gray-400 text-center">
                        Don't have an account?{' '}
                        <button
                            className="text-orange-500 underline"
                            onClick={() => navigate('/signup')}
                        >
                            Sign up
                        </button>
                    </p>
                </div>
            </div>
            {/* Images/Info Section */}
            <div className="w-full lg:w-1/2 flex flex-col items-center justify-center px-4 sm:px-10 py-6 space-y-10">
                <div className="flex flex-col lg:flex-row items-center text-center lg:text-left">
                    <img src={boxImg} alt="Box" className="w-48 sm:w-60 lg:w-72 h-auto mb-4 lg:mb-0 lg:mr-6 rounded-lg shadow-xl" />
                    <h3 className="text-white font-extrabold text-xl sm:text-2xl lg:text-4xl leading-snug">
                        Box Dimension Estimator & <br />
                        <span className="text-orange-400">Truck Packing</span>
                    </h3>
                </div>
                <div className="flex flex-col lg:flex-row items-center lg:items-start text-center lg:text-left">
                    <img src={truckImg} alt="Truck" className="w-48 sm:w-60 lg:w-72 h-auto mb-4 lg:mb-0 lg:mr-6 rounded-lg shadow-xl" />
                    <div>
                        <h3 className="text-white font-bold text-lg sm:text-2xl lg:text-3xl mb-2">
                            Advanced <span className="text-orange-400">AI Algorithm</span>
                        </h3>
                        <p className="text-gray-300 text-xs sm:text-sm lg:text-base leading-relaxed max-w-md">
                            Our intelligent platform calculates optimal packing configurations using cutting-edge AI algorithms. Save space, reduce fuel costs, and streamline your logistics operations effortlessly.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
